export default __webpack_public_path__ + "static/media/codeception.d557f5e5.svg";